import React,{Component,Suspense, useEffect,useState} from 'react';
import Header from './components/header';
import Main from './components/main/';
import Footer from './components/footer';
import './i18n';
import {LinearProgress} from '@material-ui/core';

function App() {

const [load,setload]=useState(false);

  document.onreadystatechange=()=>{
    setload(document.readyState==="complete")
  }
  return (
    <div>
    { load ?
      <Suspense fallback={null}>
    <div style={{ width:"100%" }}>
    <Header/>
      <Main/>
      <Footer/>
    </div>
    </Suspense>
  :
  <div style={{ height:"100vh",width:"100vw",display:"flex",justifyContent:"space-around", placeItems:"center",flexDirection:"column" }}>
  please wait , the page is loading Now! .. <br/>
  <LinearProgress style={{width:"50vw"}}/>
  <LinearProgress style={{width:"50vw"}} color="secondary" />
  <LinearProgress style={{width:"50vw"}}/>
  <LinearProgress style={{width:"50vw"}} color="secondary" />
  </div>
  }
    </div>
  );
}


export default App;
